<template>
  <div class="overlay" @click="$emit('close')">
    <div class="dlg" @click.stop>
      <h3 class="dlg-title">Asignar el plan</h3>

      <!-- Aquí no se elige a nadie: el responsable de un plan es el gerente del
           área a la que se asignó. Esta pantalla solo confirma quién es y deja
           claro qué falta cuando el área todavía no lo tiene capturado. -->
      <p class="dlg-hint">
        El plan está asignado al área <strong>{{ plan.area || "—" }}</strong>.
      </p>

      <div v-if="plan.gerenteArea" class="destino">
        <span class="destino-lbl">Responsable</span>
        <span class="destino-nombre">{{ plan.gerenteArea }}</span>
        <span class="destino-rol">gerente del área {{ plan.area }}</span>
      </div>

      <p v-else class="sin-gerente">
        <strong>El área {{ plan.area }} no tiene gerente capturado.</strong>
        No hay a quién asignarle el plan todavía. Hay que registrar al gerente
        del área antes de continuar; el plan se queda esperando, no se pierde.
      </p>

      <p v-if="error" class="dlg-error">{{ error }}</p>

      <div class="dlg-btns">
        <button class="btn ghost" :disabled="busy" @click="$emit('close')">
          Cancelar
        </button>
        <button
          class="btn primary"
          :disabled="busy || !plan.gerenteArea"
          :title="plan.gerenteArea ? '' : 'El área no tiene gerente capturado'"
          :style="{ background: busy || !plan.gerenteArea ? '#cbd5e1' : '#003ca5' }"
          @click="$emit('confirm', {})"
        >
          {{ busy ? "Asignando…" : "Asignar y notificar" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AsignarModal",
  props: {
    plan: { type: Object, required: true },
    busy: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["close", "confirm"],
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.45);
}
.dlg {
  width: 100%;
  max-width: 420px;
  background: var(--pt-card);
  color: var(--pt-text);
  border-radius: 14px;
  padding: 20px;
}
.dlg-title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
}
.dlg-hint {
  margin: 0 0 14px;
  font-size: 13px;
  color: var(--pt-dim);
  line-height: 1.4;
}
.destino {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 14px;
  border-radius: 10px;
  background: var(--pt-elev);
  margin-bottom: 14px;
}
.destino-lbl {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--pt-muted);
}
.destino-nombre {
  font-size: 15px;
  font-weight: 700;
}
.destino-rol {
  font-size: 12px;
  color: var(--pt-dim);
}
.sin-gerente {
  margin: 0 0 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: var(--pt-elev);
  border-left: 3px solid #d97706;
  font-size: 13px;
  line-height: 1.5;
  color: var(--pt-dim);
}
.sin-gerente strong {
  display: block;
  margin-bottom: 4px;
  color: var(--pt-text);
}
.dlg-error {
  margin: 0 0 10px;
  font-size: 13px;
  color: #b91c1c;
}
.dlg-btns {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.btn {
  padding: 8px 14px;
  border: 0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.btn:disabled {
  cursor: not-allowed;
}
.btn.ghost {
  background: var(--pt-elev);
  color: var(--pt-text);
}
.btn.primary {
  color: #fff;
}
</style>
